import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AccessUserInfo, LabActionItemTabDetail, LabRequest, UserDetail, UserLocationFacility, overdue } from 'src/app/models';
import { LoaderService } from 'src/app/services/loader.service';
import { CustomDialogService } from 'src/app/services/utility/custom-dialog.service';
import { LabActionItemService } from 'src/app/services/water-lab/lab-action-item.service';
import { LabRequestHistoryComponent } from 'src/app/components/waterLab/request/lab-request-history/lab-request-history.component';
import { SelectItem} from 'primeng';
import { DialogService } from 'primeng/dynamicdialog';
import { PreviewLabelComponent } from '../../request/preview-label/preview-label.component';
import { Router } from '@angular/router';
import { WorkFlow } from 'src/app/enum/water-lab/workFlow';
import { UserService } from 'src/app/services';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { CustomDatePipe } from 'src/app/pipes';
@Component({
  selector: 'bart-overdue-labs',
  templateUrl: './overdue-labs.component.html',
  styleUrls: ['./overdue-labs.component.scss'],
  providers: [DialogService, CustomDialogService,CustomDatePipe],
})
export class OverdueLabsComponent implements OnInit {
  @Input() selectedFacilityMasterId : number;
  @Input() userFacilities :UserLocationFacility [];
  @Input() tabDetails:LabActionItemTabDetail
  cols: any[];
  overdueActionItems: overdue[]=[];
  facilityList: SelectItem[] = [];
  public userInfo: UserDetail;
   facilityDisplayName: string ="";
  @Output() refreshTabCount: EventEmitter<any> = new EventEmitter();
  constructor(public dialogService: CustomDialogService,
     private _labActionItemService:LabActionItemService, 
     private _loaderService:LoaderService,   
     private router: Router,
     private _userService: UserService,
     private customDatePipe: CustomDatePipe,
     )
   { }
 
  ngOnInit() 
  {
    this.userInfo = AccessUserInfo.getUserInfo();
      this.cols = 
      [
        { field: 'RequestID', header: 'Request ID',display: 'table-cell', width: "15%"  },
        { field: 'EquipmentDisplayName', header: 'Model # | Nickname | Serial # | Equipment ID', display: 'table-cell', width: "35%" },
        { field: 'Frequency', header: 'Frequency' ,display: 'table-cell', width: "17%" },
        { field: 'LastShippingManifestDate', header: 'Last Shipping Manifest',display: 'table-cell', width: "17%"  },
        { field: 'DaysOverdue', header: 'Days Overdue',display: 'table-cell', width: "10%"  },
        { field: 'LabelsPrintedDate', header: 'Labels Printed',display: 'table-cell', width: "12%"  },  
      ];

      this.getOverdueActionItems();
      this.facilityDisplayName=this.userFacilities.find(x=>x.FacilityMasterID==this.selectedFacilityMasterId).FacilityDisplayName;
       //#region User Action Audit
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.FILTER,
        screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
        screenPath: location.pathname,
        key: "FacilityMasterID",
        value: this.selectedFacilityMasterId,
        eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_OVERDUE_GRID_LOADED
      });
      //#endregion
  }
  getOverdueActionItems(){
    this._loaderService.show()
    let getNoLabRequestActionItemsParams = {
      "GETOVERDUEACTIONITEMS": {
        FacilityMasterID: this.selectedFacilityMasterId
      },
    }
    this.overdueActionItems = [];
    this._labActionItemService.getOverdueActionItems(JSON.stringify(getNoLabRequestActionItemsParams)).subscribe(data => {
      this.overdueActionItems = data.GetOverdueActionItems;
      if (this.overdueActionItems) {
        this.overdueActionItems.forEach((item) => {
          item.LabelsPrintedDate = this.customDatePipe.transform(
            item.LabelsPrintedDate,
            "local",
            "MM/dd/yyyy HH:mm"
          );
          item.LabelsPrintedDateSort = new Date(
            this.customDatePipe.transform(
              item.LabelsPrintedDate,
              "local",
              "MM/dd/yyyy HH:mm"
            )
          );
          item.LastShippingManifestDate = this.customDatePipe.transform(
            item.LastShippingManifestDate,
            "local",
            "MM/dd/yyyy HH:mm"
          );
          item.LastShippingManifestDateSort = new Date(
            this.customDatePipe.transform(
              item.LastShippingManifestDate,
              "local",
              "MM/dd/yyyy HH:mm"
            )
          );

        }
        );
      }
      if(this.overdueActionItems && this.tabDetails.RecordCount!=this.overdueActionItems.length)
      {
        this.tabDetails.RecordCount=this.overdueActionItems.length
      }

      this._loaderService.hide()
     
    },
      err => {
        this._loaderService.hide()
      });

}
openHistoryPopup(rowData) {
  const ref = this.dialogService.open(LabRequestHistoryComponent, {
    header: 'Lab Request History',
    width: '90%',
    styleClass:'lab-request-history-model-popup',
    data: { labRequestId: rowData.RequestID, facilityDisplayName: this.facilityDisplayName,selectedFacilityMasterId:this.selectedFacilityMasterId,userLocationFacilities:this.userFacilities }

  });

  //#region User Action Audit
  this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.BUTTON_CLICKED,
    screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
    screenPath: location.pathname,
    key: "LabRequestID",
    value: rowData.RequestID,
    eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_OVERDUE_HISTORY_ICON_CLICKED
  });
  //#endregion
}




openPreviewLabelPopup(rowData) {
 
  const ref = this.dialogService.open(PreviewLabelComponent, {
    header: WorkFlow.HOME==rowData.WorkFlow?'Home Label Summary':'Label Summary',
    styleClass:"preview-label-summary-popup",
    data:
    {
      labRequestId:rowData.RequestID,
      facilityMasterId:this.selectedFacilityMasterId,
      facilityDisplayName:this.facilityDisplayName,
      workFlow:rowData.WorkFlow,
    }
  });
  ref.onClose.subscribe((data) => 
  {
    this.refreshTabCount.emit();
  });

   //#region User Action Audit
   this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.BUTTON_CLICKED,
    screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
    screenPath: location.pathname,
    key: "LabRequestID",
    value: rowData.RequestID,
    eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_OVERDUE_PREVIEW_LABEL_BUTTON_CLICKED
  });
  //#endregion
  
  
}


sortColumn(event) {
  //#region User Action Audit
  this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.SORT,
    screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
    screenPath: location.pathname,
    key: event.field,
    value: event.order === 1 ? 'ASC' : 'DESC',
    eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_OVERDUE_COLUMN_SORT
  });
  //#endregion
}
paginate(event) {
  //#region User Action Audit
  this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.PAGE_CHANGED,
    screenName: ScreenName.LABREQUEST_ACTION_ITEMS,
    screenPath: location.pathname,
    key: 'Selected_Page_No',
    value: (event.first / event.rows) + 1,
    eventDescription:UserActionDescription.LABREQUEST_ACTION_ITEMS_OVERDUE_PAGE_NO_CLICKED
  });
  //#endregion
}



}
